export const SELECTED_STATUS = {
  NONE: 0,
  PARTIAL: 1,
  ALL: 2
};
